import {Outlet, Route, Routes} from "react-router-dom";
import {Col, Container, Row} from "react-bootstrap";
import LoginForm from "./modules/core/components/LoginForm";
import RegisterForm from "./modules/core/components/RegisterForm";
import HomePage from "./pages/HomePage";
import { SwitchLocale } from "./modules/core/components/locale/SwitchLocale";

function ContentUnauthorized() {
    return (

        <div className="App">
            <nav className="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
                <div className="container-fluid">
                    <a className="navbar-brand" href="/">Menote.ru</a>
                    {/*<button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarCollapse">
                    <ul className="navbar-nav me-auto mb-2 mb-md-0">
                        <li className="nav-item">
                        <a className="nav-link active" aria-current="page" href="#">Home</a>
                        </li>
                        <li className="nav-item">
                        <a className="nav-link" href="#">Link</a>
                        </li>
                        <li className="nav-item">
                        <a className="nav-link disabled" href="#" tabindex="-1" aria-disabled="true">Disabled</a>
                        </li>
                    </ul>      
                    </div> */}
                    <SwitchLocale/>
                </div>
            </nav>

            <Container fluid className="m-0 p-0">
                <Row className="justify-content-md-center" >
                    <Col>
                        <Routes>
                            <Route exact path="/" element={<HomePage/>}/>
                            <Route exact path="/login" element={<LoginForm/>}/>
                            <Route exact path="/register" element={<RegisterForm/>}/>
                        </Routes>
                    </Col>
                </Row>
            </Container>
            <Outlet/>
        </div>
    );
}

export default ContentUnauthorized